// Components==============
import React, { useEffect, useRef } from 'react';
import './HiddenInput.module.scss';
// =========================

export default function HiddenInput({ effect }: { effect: any }) {
    const hiddenRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        hiddenRef?.current?.focus();
    }, [effect]);

    return (
        <input type="text" name="hidden" styleName="wrapper" ref={hiddenRef} />
    );
}
